import FAQScreen from '../screens/FAQ'
import AppFAQScreen from '../screens/App-FAQ'
import { NextPage } from 'next'
import { ScreenWidthPort } from '../ScreenWidthContext'

export const FAQ: NextPage = () => {
  const { showDesktopUI } = ScreenWidthPort()

  return (
    <>
      {showDesktopUI ? (<FAQScreen />) : (<AppFAQScreen />)}
    </>
  )
}
